/**
 * The buyer's shortlist on a branded line sheet (KP-4545): product ids kept in
 * this browser only, per sheet. A convenience, never a record: private windows,
 * blocked storage and quota errors all end with an empty or unsaved list and a
 * page that still works.
 */

const PREFIX = 'kp-ls-shortlist:'
const MAX_ITEMS = 200

export const shortlistKey = token => `${PREFIX}${token}`

export function loadShortlist(token) {
  try {
    const raw = window.localStorage.getItem(shortlistKey(token))
    const list = raw ? JSON.parse(raw) : []
    return Array.isArray(list) ? list.filter(id => typeof id === 'string').slice(0, MAX_ITEMS) : []
  } catch (e) {
    return []
  }
}

export function saveShortlist(token, ids) {
  try {
    window.localStorage.setItem(shortlistKey(token), JSON.stringify(ids.slice(0, MAX_ITEMS)))
  } catch (e) {
    // Storage blocked or full: the shortlist lives for this visit only.
  }
}

/** A new list with id added, or removed when it was there. */
export function toggleShortlist(ids, id) {
  return ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id]
}

/**
 * The list following the liked state the feedback store holds (KP-4572):
 * a style it holds as liked is on, one it holds as not liked is off, and ids
 * it does not know (hearted before feedback, or while it was down) stay as
 * they are. The same list when nothing changes.
 */
export function withServerLikes(ids, items) {
  const known = Object.entries(items || {})
  const unliked = new Set(known.filter(([, item]) => !item.liked).map(([id]) => id))
  const kept = ids.filter(id => !unliked.has(id))
  const added = known.filter(([id, item]) => item.liked && !kept.includes(id)).map(([id]) => id)
  if (!added.length && kept.length === ids.length) return ids
  return [...kept, ...added].slice(0, MAX_ITEMS)
}
